import { Component, OnInit } from "@angular/core";
import { ReferenceDrawerService } from "@services/reference-drawer/reference-drawer.service";
import { ReferenceDrawerItemInfo } from "@shared/models/reference-drawer-item-info.model";
import { DrawerService } from "projects/gene-ai-ui/src/public-api";
import { tap } from "rxjs";

@Component({
    selector: "app-reference-drawer",
    templateUrl: "./reference-drawer.component.html",
    styleUrls: ["./reference-drawer.component.css"]
})
export class ReferenceDrawerComponent implements OnInit {
    sources: ReferenceDrawerItemInfo[] = [];
    
    drawerId = "references-drawer";

    constructor(
        private referenceDrawerService: ReferenceDrawerService,
        private drawerService: DrawerService
    ) { }

    ngOnInit(): void {
        this.referenceDrawerService.referenceState
            .pipe(
                tap(({ sources, visible }) => {
                    this.sources = this.referenceDrawerService.toReferenceItems(sources);
                    if (visible) this.drawerService.show(this.drawerId);
                })
            )
            .subscribe();
    }

    onDrawerClosed(): void {
        this.referenceDrawerService.clearReferences();
    }

    get sourceCountLabel(): string {
        const count = this.sources.length;
        return count === 1 ? "1 source used" : `${count} sources used`;
    }
}
